import {get,post} from './http'

// 添加家长定制任务
export const addParentTask = (params) => post('/min-program/v1/parentTask/addParentTask',params);
// 删除家长定制任务
export const deleteParentTask = (taskId) => get('/min-program/v1/parentTask/deleteParentTask?taskId='+taskId);
// 获取家长定制任务
export const getTParentTask = (taskId) => get('/min-program/v1/parentTask/getTParentTask?taskId='+taskId);
// 家长定制任务列表
export const parentTaskList = (params) => get('/min-program/v1/parentTask/parentTaskList',params);
// 修改家长定制任务
export const updateParentTask = (params) => post('/min-program/v1/parentTask/updateParentTask',params);